import React from 'react'
import SuccessNetwork from 'src/NetworkViews/layouts/success'
const SuccessPage: React.FC = () => {
    return <SuccessNetwork />
}

export default SuccessPage
